export default __webpack_public_path__ + "cace9b9.png";